module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJFBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNVrO7804WWAAAAC3RSTlMAEIDf/79gAFDvQCzAXzYAAAB7SURBVHgB7cqhDYRAEAXQvSo2p+8qICQkSBiogFABVIAYQgMEicMjrgiaO7OYv1+zZp5+7vb6COi9Bk6DTSIlpkWIFdLE0g5pYKmC1LFUQxIqdboiDyRLlixZsmTJEpE65ew0kL4stZDeLBWQZpZ+kPSMz6GYdMSTeQ3+7+gsbB746T0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4f1.png
// module id = 1064
// module chunks = 0